import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";
import submit from "submit-form";
import SvgIcon from "../SvgIcon";

const FilterBlockReviewModal = ({ filtersModal, exerciseFilters }) => {
  const { t } = useTranslation("coaching-portal");
  const exercises = filtersModal ? JSON.parse(filtersModal) : [];
  const [filterState, setFilterState] = useState([""]);
  useEffect(() => {
    if (exerciseFilters) {
      setFilterState(JSON.parse(exerciseFilters));
    }
  }, [exerciseFilters]);

  const handleSelectionChange = (value) => {
    let data = JSON.parse(JSON.stringify(filterState));
    if (!filterState.includes(value)) {
      data.length === 1 && data[0].length === 0
        ? (data = [value])
        : data.push(value);
    } else {
      if (filterState.length > 0) {
        const filetered = data.filter((val) => val != value);
        data = filetered.length > 0 ? filetered : [""];
      }
    }
    setFilterState(data);
  };
  const setFiltersSubmit = () => {
    if (filterState.length > 0 && filterState[0].length !== 0) {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          exerciseFilters: JSON.stringify(filterState),
          modal: "",
          filtersModal: "",
        },
      });
    } else {
      submit(`/actions/refresh/?`, {
        method: "GET",
        body: {
          exerciseFilters: "",
          modal: "",
          filtersModal: "",
        },
      });
    }
  };
  return (
    <Modal
      className={"filter-exercise-video-list-modal"}
      title={t("filterBlockReview.title")}
    >
      <div className="body">
        {exercises.length > 0 && (
          <div className="select-all-btn">
            <div
              role="checkbox-wrapper"
              onClick={() => setFilterState(exercises)}
              className={
                filterState.length === exercises.length ? "active" : ""
              }
            >
              <SvgIcon
                src={
                  filterState.length === exercises.length
                    ? "/img/new-icons/checked-square.svg"
                    : "/img/new-icons/unchecked-square.svg"
                }
              />
              <span>{t("filterBlockReview.selectAll")}</span>
            </div>
          </div>
        )}
        <div className="video-filters-wrapper">
          {exercises.map((exercise, index) => (
            <div
              role="checkbox-wrapper"
              key={`${exercise}${index}`}
              id={`${exercise}${index}`}
              className={
                filterState.length === exercises.length ? "active" : ""
              }
            >
              <SvgIcon
                src={
                  filterState.includes(exercise)
                    ? "/img/new-icons/checked-square.svg"
                    : "/img/new-icons/unchecked-square.svg"
                }
                onClick={() => handleSelectionChange(exercise)}
              />

              <span>
                {exercise.charAt(0).toUpperCase() + exercise.slice(1)}
              </span>
            </div>
          ))}
        </div>
      </div>
      <footer>
        <button
          data-button-type="secondary"
          onClick={() => setFilterState([""])}
        >
          {t("filterBlockReview.clearAll")}
        </button>

        <button data-button-type="primary" onClick={setFiltersSubmit}>
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
};

export default FilterBlockReviewModal;
